import { render, staticRenderFns } from "./ClientsEditClientTabInformation.vue?vue&type=template&id=600bdd5d"
import script from "./ClientsEditClientTabInformation.vue?vue&type=script&lang=js"
export * from "./ClientsEditClientTabInformation.vue?vue&type=script&lang=js"
import style0 from "./ClientsEditClientTabInformation.vue?vue&type=style&index=0&id=600bdd5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports